import { SpkFarmContainer } from '@/features/spk/farm/SpkFarmContainer'

export function SpkFarm() {
  return <SpkFarmContainer />
}
